import { OverlayConfig } from '@angular/cdk/overlay';

export enum TimeoutTypeEnum {
  IDLE_SESSION = 'IDLE_SESSION',
  LOGOUT = 'LOGOUT',
}

export const OVERLAY_CONFIG_BY_TYPE: Record<TimeoutTypeEnum, OverlayConfig> = {
  [TimeoutTypeEnum.IDLE_SESSION]: {
    hasBackdrop: true,
    backdropClass: 'cdk-overlay-transparent-backdrop',
    height: '100vh',
    width: '100vw',
  },
  [TimeoutTypeEnum.LOGOUT]: {
    hasBackdrop: false,
    backdropClass: 'cdk-overlay-transparent-backdrop',
    height: '100vh',
    width: '100vw',
  },
};
export const SESSION_TIMEOUT = 420 * 1000;
